
// region JS Imports

// region External Modules
import $ from "jquery"
import on_domready from "domready"
import I18n from "plugins/i18n-js"
// endregion External Modules

// Private Modules
import DataRetriever from "app/data_retriever"
import {q_ajax_3} from "app/utils/q_ajax/q_ajax_3"
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"
import {
  performance,
} from "plugins/user-timing-polyfill"
import ImageLazyLoading from "widgets/image_lazyloading"
// Private Modules

// region Public Components
import {
  init as listing_shortlist_button_init,
} from "concepts/listings/listing_shortlist_button/index"
import Contact_Modal from "concepts/listings/contact/request/modal"
import FloorPlanImagesCarousel from "concepts/floor_plan/images/carousel/index"
import CitiesPublicTransportInfoTable from "concepts/cities/public_transport/info/index"
import Listings_Carousel from "concepts/listings/carousel"
import Listings_PropertySummary_Box_SometimesCollapsedStyle from "concepts/listings/property_summary/box/sometimes_collapsed_style/index"
import * as RealEstate_Mortgages_Calculator from "concepts/real_estate/mortgages/calculator/calculator"
import BannerAdvertisements from "concepts/listings/banner/advertisements/index"
import CopyableURLBoxFactory from "concepts/shared/copyable_url_box/index"
import {
  default as Buildings_Following_Modal,
  FollowTypes as BuildingFollowTypes,
} from "concepts/buildings/following/modal/index"

import TransactionAnalytics from "concepts/neighbourhoods/market_data_overview/index"
// endregion Public Components

// region Private Components
import Listings_MainSection from "apps/spacious_website/pages/listings/single_listing_details_page/components/main_section/index"

import section_navbar from "./components/section_navbar/index"

import {
  load_and_inject_content as load_and_inject_below_the_fold_section,
} from "./below_the_fold_section"
// endregion Private Components

// endregion JS Imports


const init = () => {
  Listings_Carousel.init()
  Listings_MainSection.init()

  listing_shortlist_button_init().done()

  CopyableURLBoxFactory.create()

  if (DataRetriever.get("should-show-follow-prompt")) {
    Buildings_Following_Modal.show(
      DataRetriever.get("is-commercial") === true ?
        BuildingFollowTypes.COMMERCIAL :
        BuildingFollowTypes.RESIDENTIAL,
    )
  }

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  if (urlParams.get("show_contact_modal")) {
    showContactModal()
  }

  on_domready(() => {
    const listing_id = DataRetriever.get("listing-id")

    performance.mark("spacious_mark__load_and_inject_below_the_fold_section__start")
    load_and_inject_below_the_fold_section(listing_id)
    .then(() => {
      performance.mark("spacious_mark__load_and_inject_below_the_fold_section__end")
      performance.measure(
        "spacious_measure__load_and_inject_below_the_fold_section",
        "spacious_mark__load_and_inject_below_the_fold_section__start",
        "spacious_mark__load_and_inject_below_the_fold_section__end",
      )

      performance.mark("spacious_mark__below_the_fold_section_init__start")

      ImageLazyLoading.default_lazyload_instance().update()
      BannerAdvertisements.init()

      WaitObjectByPathPromise("window._spacious_main_css_loaded")
      .then(() => {
        $(".page-section-title-bar__arrow").on("click", (e) => {
          const $this = $(e.currentTarget)
          $this.parents(".page-section").toggleClass("hide-content")
        })

        section_navbar.init()

        FloorPlanImagesCarousel.init()
        TransactionAnalytics.init().done()
        RealEstate_Mortgages_Calculator.init_async().done()
        CitiesPublicTransportInfoTable.init()
        Listings_PropertySummary_Box_SometimesCollapsedStyle
        .init_with_promise().done()
      })
      .done()
    })
  })
}

function showContactModal() {
  const listing_id =  DataRetriever.get("listing-id")

  q_ajax_3({
    url:      `/${I18n.locale}/listings/${listing_id}/contact_request`,
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    return Contact_Modal.loadAndShowModal(data)
  })
  .done()
}


export default {
  init,
}
